<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} ArchiveReason` }}
            </h4>
            <v-form ref="archiveReasonForm" @submit.prevent="save()">
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="archiveReasonModel.name"
                    label="ArchiveReason Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'ArchiveReason Name is required']"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-select
                    :items="['deals', 'leads', 'enquires']"
                    label="Select Type"
                    v-model="archiveReasonModel.type"
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { ArchiveReason } from "@/models/ArchiveReason";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      archiveReasonModel: new ArchiveReason(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "ArchiveReasons",
          disabled: false,
          href: "/admin/archiveReasons",
        },
        {
          text: "ArchiveReason Detail",
          disabled: false,
          href: `/admin/archiveReason/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} ArchiveReason`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    archiveReason: {
      query: gql`
        query ArchiveReason($id: ID!) {
          archiveReason(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.archiveReasonModel.id = this.archiveReason.id;
        this.archiveReasonModel.name = this.archiveReason.name;
        this.archiveReasonModel.type = this.archiveReason.type;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.archiveReasonForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateArchiveReason()
          .then(() => {
            this.$swal("Success!", "ArchiveReason was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the archiveReason, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createArchiveReason()
          .then(() => {
            this.$swal("Success!", "Archive Reason was created", "success");
            window.location.href = `/admin/archiveReasons`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the archiveReason, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateArchiveReason() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($archiveReason: ArchiveReasonUpdateInput!) {
              updateArchiveReason(archiveReason: $archiveReason) {
                id
                updated
              }
            }
          `,
          variables: {
            archiveReason: {
              id: self.archiveReasonModel.id,
              name: self.archiveReasonModel.name,
              type: self.archiveReasonModel.type,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the archiveReason!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createArchiveReason() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createArchiveReason(
              $archiveReason: ArchiveReasonCreateInput!
            ) {
              createArchiveReason(archiveReason: $archiveReason) {
                id
              }
            }
          `,
          variables: {
            archiveReason: {
              name: self.archiveReasonModel.name,
              type: self.archiveReasonModel.type,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the ArchiveReason Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createArchiveReason) {
          self.archiveReasonModel.id = response?.data?.createArchiveReason?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
